import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PlatformBrowserDirective } from './platform-browser.directive';

@NgModule({
  declarations: [PlatformBrowserDirective],
  imports: [CommonModule],
  exports: [PlatformBrowserDirective]
})
export class PlatformModule {}

export * from './platform.service';
export * from './platform-browser.directive';
